// FETCH ALL PROPERTIES FROM COMPANY MASTER
export const FETCH_COMPANY_MASTER_REQUEST = 'FETCH_COMPANY_MASTER_REQUEST';
export const FETCH_COMPANY_MASTER_SUCCESS = 'FETCH_COMPANY_MASTER_SUCCESS';
export const FETCH_COMPANY_MASTER_FAILURE = 'FETCH_COMPANY_MASTER_FAILURE';

// CREATE PROPERTIES FOR COMPANY MASTER
export const CREATE_COMPANY_MASTER_REQUEST = 'CREATE_COMPANY_MASTER_REQUEST';
export const CREATE_COMPANY_MASTER_SUCCESS = 'CREATE_COMPANY_MASTER_SUCCESS';
export const CREATE_COMPANY_MASTER_FAILURE = 'CREATE_COMPANY_MASTER_FAILURE';

export const IMAGE_UPLOAD_COMPANY_MASTER_REQUEST = 'IMAGE_UPLOAD_COMPANY_MASTER_REQUEST';
export const IMAGE_UPLOAD_COMPANY_MASTER_SUCCESS = 'IMAGE_UPLOAD_COMPANY_MASTER_SUCCESS';
export const IMAGE_UPLOAD_COMPANY_MASTER_FAILURE = 'IMAGE_UPLOAD_COMPANY_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_COMPANY_MASTER = 'CREATE_USER_FORM_COMPANY_MASTER';

//UPDATE USER FORM
export const UPDATE_USER_FORM_COMPANY_MASTER = 'UPDATE_USER_FORM_COMPANY_MASTER';

//GET PROPERTY FROM PROPERTY TABLE
export const PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST = 'PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST';
export const PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS = 'PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS';
export const PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE = 'PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE';

//GET AREA FROM AREA TABLE
export const AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST = 'AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST';
export const AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS = 'AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS';
export const AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE = 'AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE';

// UPDATE PROPERTIES FOR COMPANY MASTER
export const UPDATE_COMPANY_MASTER_REQUEST = 'UPDATE_COMPANY_MASTER_REQUEST';
export const UPDATE_COMPANY_MASTER_SUCCESS = 'UPDATE_COMPANY_MASTER_SUCCESS';
export const UPDATE_COMPANY_MASTER_FAILURE = 'UPDATE_COMPANY_MASTER_FAILURE';

// FETCH SINGLE COMPANY
export const FETCH_SINGLE_COMPANY_MASTER_REQUEST = 'FETCH_SINGLE_COMPANY_MASTER_REQUEST';
export const FETCH_SINGLE_COMPANY_MASTER_SUCCESS = 'FETCH_SINGLE_COMPANY_MASTER_SUCCESS';
export const FETCH_SINGLE_COMPANY_MASTER_FAILURE = 'FETCH_SINGLE_COMPANY_MASTER_FAILURE';


// FETCH COMPANY LOGO
export const FETCH_LOGO_COMPANY_MASTER_REQUEST = 'FETCH_LOGO_COMPANY_MASTER_REQUEST';
export const FETCH_LOGO_COMPANY_MASTER_SUCCESS = 'FETCH_LOGO_COMPANY_MASTER_SUCCESS';
export const FETCH_LOGO_COMPANY_MASTER_FAILURE = 'FETCH_LOGO_COMPANY_MASTER_FAILURE';

// DELETE PROPERTIES FOR COMPANY MASTER
export const DELETE_COMPANY_MASTER_REQUEST = 'DELETE_COMPANY_MASTER_REQUEST';
export const DELETE_COMPANY_MASTER_SUCCESS = 'DELETE_COMPANY_MASTER_SUCCESS';
export const DELETE_COMPANY_MASTER_FAILURE = 'DELETE_COMPANY_MASTER_FAILURE';

// USERFORM RESET

export const COMPANY_MASTER_USERFORM_RESET = 'COMPANY_MASTER_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_UNIT_MASTER = 'NAVIGATE_UNIT_MASTER';
// navigate to company component
export const NAVIGATE_COMPANY_MASTER = 'NAVIGATE_COMPANY_MASTER';
